import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";

const loadScript = () =>
    new Promise((resolve, reject) => {
        if (window.Razorpay) return resolve();
        const s = document.createElement("script");
        s.src = SCRIPT;
        s.onload = resolve;
        s.onerror = reject;
        document.body.appendChild(s);
    });

export const useRazorpay = () => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        axios.get(`${API}/payments/config`).then(({ data }) => setEnabled(!!data.razorpay)).catch(() => {});
    }, []);

    const pay = async ({ form, cart, onSuccess, onDismiss }) => {
        await loadScript();
        const { data } = await axios.post(`${API}/payments/razorpay/order`, {
            ...form,
            items: cart.map((i) => ({ product_id: i.id, qty: i.qty })),
        });
        const rzp = new window.Razorpay({
            key: data.key_id,
            amount: data.amount,
            currency: data.currency,
            order_id: data.razorpay_order_id,
            name: "Al Zahra Perfumery",
            description: "Attar order",
            prefill: data.prefill,
            theme: { color: "#B8963E" },
            modal: { ondismiss: onDismiss },
            handler: async (res) => {
                await axios.post(`${API}/payments/razorpay/verify`, res);
                onSuccess(data.razorpay_order_id);
            },
        });
        rzp.open();
    };

    return { enabled, pay };
};
